import React, { useContext } from "react"
import { Floor, Span, StakeWrapper } from "../FloorStyled"
import {
  Button,
  mathOperations,
  SFXS,
  Currencies,
} from "@orbital/games-frontend-library"
import { MyContext } from "../../../../../../context/createContext"

export default function SecondFloor({
  stake,
  handleStake,
  handleModal,
  handleNotification,
  audio,
}: any) {
  const { ctx } = useContext(MyContext)
  const { config, auth } = ctx
  const toFix = config.prec
  return (
    <Floor>
      <Button
        background="#D29809"
        textColor="#181731"
        func={(e?: boolean) =>
          e &&
          handleStake(
            mathOperations(
              stake,
              "1/2",
              toFix,
              config.maxbet,
              config.minbet,
              handleNotification,
              auth.balance.currency
            )
          )
        }
        SFX={SFXS.divideSFX}
        handleNotification={handleNotification}
        audio={audio}
      >
        1/2
      </Button>
      <Button
        background="transparent"
        border="3px solid #ffb000"
        textColor="#ffb000"
        size="15px"
        width="164px"
        height="51px"
        audio={audio}
        func={(b: boolean) => b && handleModal("setStake")}
        SFX={SFXS.goForwardSFX}
      >
        <StakeWrapper>
          <Span>{Currencies[auth.balance.currency]}</Span>
          <Span>{stake}</Span>
        </StakeWrapper>
      </Button>
      <Button
        background="#D29809"
        textColor="#181731"
        func={(e?: boolean) =>
          e &&
          handleStake(
            mathOperations(
              stake,
              "2x",
              toFix,
              config.maxbet,
              config.minbet,
              handleNotification,
              auth.balance.currency
            )
          )
        }
        audio={audio}
        SFX={SFXS.multiplySFX}
        handleNotification={handleNotification}
      >
        2x
      </Button>
    </Floor>
  )
}
